/* Radio Country Collection — filter chips + FAQ accordion + brief form confirm */
(function () {
  function init(root) {
    if (!root || root.dataset.rccBound === "1") return;
    root.dataset.rccBound = "1";

    var grid = root.querySelector("[data-rcc-grid]");
    var cards = grid ? grid.querySelectorAll("[data-rcc-card]") : [];
    var countLabel = root.querySelector("[data-rcc-count]");
    var totalLabel = root.querySelector("[data-rcc-total]");
    var empty = root.querySelector("[data-rcc-empty]");
    var langChips = root.querySelectorAll("[data-rcc-lang-chip]");
    var fmtChips = root.querySelectorAll("[data-rcc-fmt-chip]");
    var state = { lang: "All", fmt: "All" };

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (c) {
        var langs = (c.getAttribute("data-langs") || "").split("|").map(function (s) { return s.trim(); });
        var fmts = (c.getAttribute("data-fmts") || "").split("|").map(function (s) { return s.trim(); });
        var langOk = state.lang === "All" || langs.indexOf(state.lang) !== -1;
        var fmtOk = state.fmt === "All" || fmts.indexOf(state.fmt) !== -1;
        if (langOk && fmtOk) {
          c.classList.remove("is-hidden");
          visible++;
        } else {
          c.classList.add("is-hidden");
        }
      });
      if (countLabel) countLabel.textContent = visible;
      if (empty) empty.classList.toggle("is-on", visible === 0);
    }

    function bindChips(list, key) {
      list.forEach(function (chip) {
        chip.addEventListener("click", function () {
          var v = chip.getAttribute("data-value");
          state[key] = v;
          list.forEach(function (c) {
            c.classList.toggle("is-on", c === chip);
          });
          applyFilters();
        });
      });
    }
    bindChips(langChips, "lang");
    bindChips(fmtChips, "fmt");

    /* FAQ accordion */
    var faqItems = root.querySelectorAll("[data-rcc-faq-item]");
    faqItems.forEach(function (item) {
      var btn = item.querySelector(".rcc-faq-q");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var wasOpen = item.classList.contains("is-open");
        faqItems.forEach(function (i) { i.classList.remove("is-open"); });
        if (!wasOpen) item.classList.add("is-open");
      });
    });

    /* Brief form — local-only confirm (form submission is wired later) */
    var form = root.querySelector("[data-rcc-brief-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector(".rcc-brief-submit");
        if (btn) btn.textContent = "Brief sent · we'll be in touch";
      });
    }
  }

  function ready() {
    document.querySelectorAll(".rcc-page").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
})();
